import type { FunctionComponent } from 'react';
import { SimStateIndicator } from 'components';
import { type Sim } from 'utils/graphql/hooks';

export const StateColumnAccessor: FunctionComponent<Sim> = ({ state, stateReason }) => (
  <SimStateIndicator state={state} stateReason={stateReason} cursor="initial" />
);
